import { Checkbox } from "./checkbox";

export const CustomOption = (props: any) => {
    const { isSelected, label, innerRef, innerProps } = props;
  
    return (
      <div
        ref={innerRef}
        {...innerProps}
        style={{
          display: 'flex',
          alignItems: 'center',
          paddingLeft: 8,
          cursor: 'pointer',
          padding: '8px 12px',
        }}
      >
        <Checkbox
          checked={isSelected}
          onChange={(e: any) => e.preventDefault()}
          variant="solid"
          style={{ marginRight: 8 }}
          colorPalette="teal"
          className="checkbox-dropdown"
        />
        <span style={{ fontSize: 13 }}>{label}</span>
      </div>
    );
  };